// Description: This file contains constants related to lexical reports.

import type { PdfConfigInput } from 'sr-types/lib/production/v1/graphql';
import type { RankFieldConfig } from '../generateReport/reportTypes';
import {
    ENTITIES,
    getCustomSortFieldConfigMap,
    getCustomSortFieldConfigs,
    getCustomSortRankOrderFields
} from './customSortFieldConfigs';

export const REPORT_CONST = 'Report';

export const REPORT_TEMPLATES_PREFERENCE_TYPE = 'preferenceType=Report';

export const FORMAT_API_ACTION = {
    view: 'View',
    manage: 'Manage'
};

export const TEMPLATE_FOR = {
    LexicalReport: 'LexicalReport'
};

export const CONTENT_TYPE = {
    PDF: 'application/pdf'
};

export const DOC_GENERATOR_URL = {
    PREVIEW: '/documentgenerator/v1/preview',
    GENERATE: '/documentgenerator/v1/generate'
};

export const layoutOptions = [
    { id: 'landscape', label: 'Landscape' },
    { id: 'portrait', label: 'Portrait' }
];

export const pageSizeOptions = [
    { id: 'A0', label: 'A0' },
    { id: 'A1', label: 'A1' },
    { id: 'A2', label: 'A2' },
    { id: 'A3', label: 'A3' },
    { id: 'A4', label: 'A4' },
    { id: 'A5', label: 'A5' },
    { id: 'A6', label: 'A6' },
    { id: 'Letter', label: 'Letter' },
    { id: 'Legal', label: 'Legal' },
    { id: 'Tabloid', label: 'Tabloid' },
    { id: 'Ledger', label: 'Ledger' }
];

export const DEFAULT_PAGE_CONFIG: PdfConfigInput = {
    pageLayout: 'portrait',
    pageSize: 'A4',
    scale: 100
};

export const WORKSPACE_RANK_FIELD_CONFIGS: RankFieldConfig[] = getCustomSortFieldConfigs(ENTITIES.workspace);

export const WORKSPACE_RANK_FIELD_CONFIG_MAP: Record<string, RankFieldConfig> = getCustomSortFieldConfigMap(
    ENTITIES.workspace
);

export const WORKSPACE_RANK_ORDER_FIELDS: Record<string, string> = getCustomSortRankOrderFields(
    ENTITIES.workspace
);
